// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"b00db11f","166":"df453ac2","341":"14518e6e","517":"a6397e27","639":"7cfac35e","815":"9d93ad9a"}[chunkId] + ".chunk.css";
};